import ProductDetailHeader from './ProductDetailHeader';

export default ProductDetailHeader;
